import { Box, PageBlock } from 'braid-design-system';

import { Background } from 'src/components/Background/Background';
import { IconFeatureBlock } from 'src/components/IconFeatureBlock/IconFeatureBlock';
import IconApplyWithSEEK from 'src/images/icon-apply-with-seek.svg';
import IconJobPosting from 'src/images/icon-job-posting.svg';
import IconOptimisedApply from 'src/images/icon-optimised-apply.svg';
import IconTSC from 'src/images/icon-talent-search-connect.svg';

export const SharedIconBlock = () => (
  <Background color="#f4f9ff">
    <PageBlock width="large">
      <Box paddingY={['xlarge', 'xxlarge']}>
        <IconFeatureBlock
          heading="What’s possible?"
          level="1"
          text="By choosing a Connected Partner, you can access SEEK's sourcing suite without leaving your own software."
          width="large"
          columns={[1, 1, 2, 4]}
          data={[
            {
              heading: 'SEEK Job Posting',
              text: 'Create effective ads and automatically post to SEEK with optimised targeting, data, insights, and enhanced screening.',
              image: {
                url: IconJobPosting,
                format: 'svg',
                width: '120px',
              },
            },
            {
              heading: 'SEEK Optimised Apply',
              text: 'Enable the optimal candidate application experience using SEEK’s Apply Form - resulting in applications with more data.',
              image: {
                url: IconOptimisedApply,
                format: 'svg',
                width: '120px',
              },
            },
            {
              heading: 'Apply with SEEK',
              text: 'Powered by SEEK Profile, candidates can prefill applications on your careers site via any device.',
              image: {
                url: IconApplyWithSEEK,
                format: 'svg',
                width: '120px',
              },
            },
            {
              heading: 'Talent Search Connect (Coming Soon)',
              text: 'A proactive sourcing tool that seamlessly integrates with your recruitment software, empowering you to find and connect with the right candidates.',
              image: {
                url: IconTSC,
                format: 'svg',
                width: '120px',
              },
            },
          ]}
        />
      </Box>
    </PageBlock>
  </Background>
);
